<template>
  <div class="page-content || no-top-pad">
    <div class="card">
      <div class="card-header">
        <h3 class="portrait-title">
          {{ content.title }}
        </h3>
        <p class="portrait-label">
          {{ content.description }}
        </p>
        <FieldInput
          name="fear"
          type="text"
          :autoComplete="false"
          labelText=""
          placeholder="eg. fear of snakes"
          :value="fear"
          :touched="true"
          :onBlur="() => null"
          :onChange="(event) => updateFear(event.target.value)"
        />
        <FieldInput
          name="email"
          type="text"
          :autoComplete="false"
          labelText=""
          placeholder="Email"
          :value="email"
          :touched="true"
          :onBlur="() => null"
          :onChange="(event) => updateEmail(event.target.value)"
        />
      </div>

      <div role="group" class="style-guide-button-group">
        <CustomButton
          variation="primary"
          :onClick="sendFearToServer"
          :disabled="buttonDisabled"
          >Email me when released</CustomButton
        >
      </div>
      <div>
        <p class="portrait-label">{{ optionData.content }}</p>
      </div>
      <SnackbarPrompt variation="success" v-if="snackbarMessage.length > 0">
        {{ this.snackbarMessage }}
      </SnackbarPrompt>
    </div>
  </div>
</template>
<script>
import CustomButton from "@/components/CustomButton.vue";
import FieldInput from "@/components/FieldInput.vue";
import SnackbarPrompt from "@/components/SnackbarPrompt.vue";
import { MODULES } from "@/config";

export default {
  components: {
    CustomButton,
    FieldInput,
    SnackbarPrompt,
  },
  data() {
    return {
      fear: "",
      email: "",
      buttonDisabled: true,
      snackbarMessage: "",
    };
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        options: {
          type: Array,
          required: true,
          default: () => [
            {
              id: String,
              label: String,
              to: String,
              icon: String,
              text: String,
              description: String,
              isActive: Boolean,
              target_field: String,
              value: [String, Boolean, Array],
            },
          ],
        },
      }),
    },
  },
  computed: {
    optionData() {
      return this.content.options[0];
    },
  },
  methods: {
    sendFearToServer() {
      const { dispatch } = this.$store;

      dispatch(`${MODULES.USER}/waitingListUser`, {
        email: this.email,
        fear: this.fear,
      })
        .then((data) => {
          this.snackbarMessage = data.message;
          //this.action()  //returns user to previous page if enabled
        })
        .catch(() => {
          this.snackbarMessage =
            "Something went wrong trying to save your fear. Please contact ovrcome support: support@ovrcome.io";
        });
    },
    updateFear(value) {
      this.fear = value;
      this.checkDisabled();
    },
    updateEmail(value) {
      this.email = value;
      this.checkDisabled();
    },
    checkDisabled() {
      if (this.email.length > 0 && this.fear.length > 0) {
        this.buttonDisabled = false;
      } else {
        this.buttonDisabled = true;
      }
    },
  },
};
</script>
